export default {
  default: () => import("/opt/buildhome/repo/layouts/default.vue"),
  empty: () => import("/opt/buildhome/repo/layouts/empty.vue")
}